export default "__VITE_ASSET__CrLn8UMx__"